export async function GetUserInfo() {
    try {
        var response =
            await fetch("/getuserinfo", { redirect: "manual" });
        // on redirect, the cookie is removed, 
        if (response.status === 401)
            return "SESSION_EXPIRED";
        return await response.json();

    }
    catch (error) {
        console.log(error);
    }
}

export async function GetConfiguration() {
    try {
        var response = await fetch("/getconfiguration");
        return await response.json();
    }
    catch (error) {
        console.log(error);
    }
}


export async function Ping() {
    try {
        var response =
            await fetch("/ping", { redirect: "manual" });
        // on redirect, the cookie is removed, 
        if (response.status === 401)
            return "SESSION_EXPIRED";
        return "";

    }
    catch (error) {
        console.log(error);
    }
}

export function RegisterTopMenuEventHandlers(onLangaugeChanged: (newLangauge:string) => void, postLogoutUrl: string) {
    const dwtopMenu = document.querySelector('dw-unifiedheader');

    dwtopMenu?.addEventListener('dwMenuLanguageChanged', ((event: CustomEvent) => {
        onLangaugeChanged(event.detail);
    }) as EventListener);

    dwtopMenu?.addEventListener('dwMenuloggedout', event => {
        fetch("/signout", { method: 'POST' }).then(function () {
            //redirect to sso logout after succesfull logout inside my account
            window.location.replace(postLogoutUrl);
        });
    });
}